import { render, staticRenderFns } from "./chemicalDisposal.vue?vue&type=template&id=85e377a8&scoped=true"
import script from "./chemicalDisposal.vue?vue&type=script&lang=js"
export * from "./chemicalDisposal.vue?vue&type=script&lang=js"
import style0 from "./chemicalDisposal.vue?vue&type=style&index=0&id=85e377a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e377a8",
  null
  
)

export default component.exports